/**
 * CommercialTrustStrip — 6-item trust/compliance row under plan cards.
 *
 * RC 1.35.F1 P0-5 — replaces the old "Subscription access coming soon —
 * paid plans use a stub activation flow..." disclaimer. Each item is
 * either a passive trust signal (Stripe / transparent billing / privacy)
 * or a clickable legal link (Terms / Refund / Privacy).
 *
 * Pure UI. No backend, no migration, no behavioural change.
 */
import { Link } from 'react-router-dom';
import {
  ShieldCheck, CircleDollarSign, BadgeCheck, Lock, FileText, Scale,
} from 'lucide-react';

const TRUST_ITEMS = [
  { icon: ShieldCheck,       label: 'Secure payments by Stripe', testid: 'trust-stripe' },
  { icon: CircleDollarSign,  label: 'Cancel any time',           testid: 'trust-cancel' },
  { icon: BadgeCheck,        label: 'Transparent billing',       testid: 'trust-transparent' },
  { icon: Lock,               label: 'Privacy protected',         testid: 'trust-privacy-badge' },
];

const LEGAL_LINKS = [
  { to: '/terms',   label: 'Terms',           icon: Scale,       testid: 'trust-terms-link' },
  { to: '/refund',  label: 'Refund Policy',   icon: FileText,    testid: 'trust-refund-link' },
  { to: '/privacy', label: 'Privacy Policy',  icon: ShieldCheck, testid: 'trust-privacy-link' },
];

export default function CommercialTrustStrip() {
  return (
    <div
      className="mt-8 pt-6 border-t border-ndor-edge space-y-4"
      data-testid="commercial-trust-strip"
    >
      <ul className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {TRUST_ITEMS.map(({ icon: Icon, label, testid }) => (
          <li
            key={label}
            data-testid={testid}
            className="flex items-center gap-2 text-xs text-ndor-ink-secondary"
          >
            <Icon className="h-4 w-4 shrink-0 text-ndor-gold" />
            <span>{label}</span>
          </li>
        ))}
      </ul>

      <p className="text-[11px] text-ndor-ink-muted leading-relaxed" data-testid="trust-legal-line">
        Secure billing powered by Stripe. Manage your subscription in
        accordance with your plan terms. By subscribing you agree to our{' '}
        {LEGAL_LINKS.map((l, i) => (
          <span key={l.to}>
            <Link
              to={l.to}
              data-testid={l.testid}
              className="text-ndor-ink hover:underline"
            >
              {l.label}
            </Link>
            {i < LEGAL_LINKS.length - 1 ? ', ' : '.'}
          </span>
        ))}
      </p>
    </div>
  );
}
